<template>
	<div>
		<!-- 功能按钮 -->
		<buttonlist @help="help" @add="add" @reflash="reflash" ref="SetBtn"></buttonlist>
		<!-- 功能按钮 -->
		<!-- 表格 -->
		<el-table
				id="xpane-0"
				:data="datajson"
				v-loading="loading"
				:highlight-current-row="false"
				show-overflow-tooltip="true"
				border
				stripe
				size="mini"
				header-row-class-name="headerclass"
				:height="tableHeight"
				@cell-dblclick="editInfo"
				tab-click="selectInfo(0)"
				@selection-change="handleSelectionChange"
				style="width: 100%; margin-top:0px"
				:header-cell-style="$limits.headerClass"
				ref="singleTable"
		>
			<el-table-column type="selection"></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="category_code" :label="$t('getapi[6880]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="category_name" :label="$t('getapi[6881]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="client_code" :label="$t('getapi[2610]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="client_name" :label="$t('getapi[2958]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="client_type_name" :label="$t('getapi[1114]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="area" :label="$t('getapi[3269]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="currency_code" :label="$t('getapi[3108]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="tax_code" :label="$t('getapi[3693]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="receive_subject_code" :label="$t('getapi[13365]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="receive_subject_name" :label="$t('getapi[13366]')"></el-table-column>
			<!--<el-table-column show-overflow-tooltip prop="tax_subject_code" :label="$t('getapi[13367]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="tax_subject_name" :label="$t('getapi[13368]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="sales_subject_code" :label="$t('getapi[13369]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="sales_subject_name" :label="$t('getapi[13370]')"></el-table-column>-->
			<el-table-column show-overflow-tooltip prop="prereceive_subject_code" :label="$t('getapi[13371]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="prereceive_subject_name" :label="$t('getapi[13372]')"></el-table-column>
			<el-table-column fixed="right" :label="$t('getapi[6048]')" width="150">
				<template slot-scope="scope">
					<el-button @click.native.prevent="edit(scope)" type="text" size="mini">{{ $t('getapi[34]') }}</el-button>
					<el-popconfirm
							:confirmButtonText="$t('getapi[6109]')"
							:cancelButtonText="$t('getapi[6]')"
							icon="el-icon-info"
							iconColor="red"
							:title="$t('getapi[637]')"
							@onConfirm="del(scope)"
					>
						<el-button slot="reference" type="text" size="mini">{{ $t('getapi[40]') }}</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<!-- 表格 -->
		<!-- 分页 -->
		<el-row class="page">
			<el-col :span="12">
				<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[50, 100, 200, 300, 400]"
						:page-size="PageSize"
						background
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="12">
				<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>
		<!-- 分页 -->
		<!-- 搜索弹框 -->
		<serce :isVisible="isVisible" queryData="salecontrolsubject" ref="ser" @getser="serclick"></serce>
		<!-- 搜索弹框 -->
		<!-- 编辑弹框 -->
		<el-dialog v-dialogDrag :visible.sync="editvisi" :title="$t('getapi[6861]')" width="33%" :close-on-click-modal="false">

			<el-divider></el-divider>
			<div :style="{border:'1px solid #DCDFE6'}">
				<table>
					<tr>
						<td>{{$t('getapi[112]')}}</td>
						<td>
							<routejump :urlNo="12">
								<el-input
										v-model="formInline.part_code"
										type="text"
										readonly
										size="mini"
								>
									<i  class="el-icon-edit el-input__icon"  slot="suffix" @click="selectpart"></i>
								</el-input>
							</routejump>
						</td>
						<td>{{$t('getapi[116]')}}</td>
						<td><el-input v-model="formInline.part_name" type="text" size="mini" :readonly="true" class="readO"></el-input></td>
					</tr>
					<tr>
						<td>{{$t('getapi[6880]')}}</td>
						<td>
							<routejump :urlNo="7">
								<el-input
										v-model="formInline.category_code"
										type="text"
										readonly
										size="mini"
								>
									<i  class="el-icon-edit el-input__icon"  slot="suffix" @click="selectcategory"></i>
								</el-input>
							</routejump>
						</td>
						<td>{{$t('getapi[6881]')}}</td>
						<td><el-input v-model="formInline.category_name" type="text" size="mini" :readonly="true" class="readO"></el-input></td>
					</tr>
					<tr>
						<td>{{$t('getapi[2610]')}}</td>
						<td>
							<routejump :urlNo="31">
								<el-input
										v-model="formInline.client_code"
										type="text"
										readonly
										size="mini"
								>
									<i  class="el-icon-edit el-input__icon"  slot="suffix" @click="selectcustomer"></i>
								</el-input>
							</routejump>
						</td>
						<td>{{$t('getapi[2958]')}}</td>
						<td><el-input v-model="formInline.client_name" type="text" size="mini" :readonly="true" class="readO"></el-input></td>
					</tr>
					<tr>
						<td>{{$t('getapi[1114]')}}</td>
						<td>
							<el-input
									v-model="formInline.client_type_name"
									type="text"
									readonly
									size="mini"
							>
								<i  class="el-icon-edit el-input__icon"  slot="suffix" @click="selectcustomertype"></i>
							</el-input>
						</td>
						<td>{{$t('getapi[3108]')}}</td>
						<td><el-input v-model="formInline.currency_code" type="text" size="mini"></el-input></td>
					</tr>
					<tr>
						<td>{{$t('getapi[3693]')}}</td>
						<td><el-input v-model="formInline.tax_code" type="text" size="mini"></el-input></td>
						<td>{{$t('getapi[3269]')}}</td>
						<td>
							<el-input
									v-model="formInline.area"
									type="text"
									readonly
									size="mini"
							>
								<i  class="el-icon-edit el-input__icon"  slot="suffix" @click="selectarea"></i>
							</el-input>
						</td>
					</tr>
					<tr>
						<td>{{$t('getapi[13365]')}}</td>
						<td>
							<el-input
									v-model="formInline.receive_subject_code"
									type="text"
									readonly
									size="mini"
							>
								<i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectSubject(1)"></i>
							</el-input>
						</td>
						<td>{{$t('getapi[13366]')}}</td>
						<td><el-input v-model="formInline.receive_subject_name" type="text" size="mini" :readonly="true" class="readO"></el-input></td>
					</tr>
					<!--<tr>
						<td>{{$t('getapi[13367]')}}</td>
						<td>
							<el-input
									v-model="formInline.tax_subject_code"
									type="text"
									readonly
									size="mini"
							>
								<i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectSubject(2)"></i>
							</el-input>
						</td>
						<td>{{$t('getapi[13368]')}}</td>
						<td><el-input v-model="formInline.tax_subject_name" type="text" size="mini" :readonly="true" class="readO"></el-input></td>
					</tr>
					<tr>
						<td>{{$t('getapi[13369]')}}</td>
						<td>
							<el-input
									v-model="formInline.sales_subject_code"
									type="text"
									readonly
									size="mini"
							>
								<i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectSubject(3)"></i>
							</el-input>
						</td>
						<td>{{$t('getapi[13370]')}}</td>
						<td><el-input v-model="formInline.sales_subject_name" type="text" size="mini" :readonly="true" class="readO"></el-input></td>
					</tr>-->
					<tr>
						<td>{{$t('getapi[13371]')}}</td>
						<td>
							<el-input
									v-model="formInline.prereceive_subject_code"
									type="text"
									readonly
									size="mini"
							>
								<i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectSubject(4)"></i>
							</el-input>
						</td>
						<td>{{$t('getapi[13372]')}}</td>
						<td><el-input v-model="formInline.prereceive_subject_name" type="text" size="mini" :readonly="true" class="readO"></el-input></td>
					</tr>
				</table>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="editvisi = false">{{ $t('getapi[6]') }}</el-button>
				<el-button size="small" type="primary" @click="sava" :loading="loading" :disabled="loading">{{ $t('getapi[937]') }}</el-button>
			</span>
		</el-dialog>
		<!-- 编辑弹框 -->
		<selector :isVisible="isVisiblecargo" :isBatch=false :isSplitPage=true
				  :postUrl="'/Basic/General/GetWCenterCargoPositionPopupList'" @callback="getCargo"
				  ref="cargo"></selector>
		<!--选择会计科目-->
		<subjecttable :isVisible="false" :isBatch=false :selectType="0" :isSplitPage="true"
					  :postUrl="'/GL/Basic/GetSubjectPopuDataList'" @callback="getSubject" ref="subject"></subjecttable>
		<!--选择物料编码-->
		<selector :isVisible="false" :selectType="11" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetPartPopuDataList'" @callback="getpart" ref="part"></selector>
		<!--选择存货类别-->
		<selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetPartCategory'" @callback="getcategory" ref="category"></selector>
		<!--客户代码 -->
		<selector :isVisible="false" :isBatch="false" :isSplitPage="true" :selectType="1" :postUrl="'Basic/Popup/GetSALCustomerDataList'"
				  @callback="getcustomer" ref="customer"></selector>
		<!--客户类型 -->
		<selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetCustomerType'" @callback="getcustomertype" ref="customertype"></selector>
		<!--地区信息 -->
		<selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetAreaInfo'" @callback="getarea" ref="area"></selector>
	</div>
</template>

<script>
    import Common from '@/components/Common';
    import urlpost from '@/api/config.js';
    export default {
        name: '3_salecontrolsubject',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                formInline: {
                    Exclusively_ID: '',
                    part_code: '',
                    part_name: '',
                    category_code: '',
                    category_name: '',
                    client_code: '',
                    client_name: '',
                    client_type_id: '',
                    client_type_name:'',
                    area: '',
                    currency_code: '',
                    tax_code: '',
                    receive_subject_code: '',
                    receive_subject_name: '',
                    tax_subject_code: '',
                    tax_subject_name: '',
                    sales_subject_code: '',
                    sales_subject_name: '',
                    prereceive_subject_code: '',
                    prereceive_subject_name: ''
                },
                oldFormInline:[],
                ids: '',
                showloading: '',
                isVisible: false,
                editvisi: false,
                DbTbNames: '', //表名
                datajson: [],
                PageIndex: 1,
                PageSize: this.$http.getPageSize('3_salecontrolsubject'),
                SelectIndex: 1,
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                queryData: [], // 查询数组
                selectIDData: '', // 选择的数据的ID集合
                subjecttype: '', //跟踪类别
                url: '', // 零件图路径
                isEdit: true, // 是否新增
                CargoPositionList: [],
                btn: {
                    del: false,
                    edit: false
                },
                workcostrateEdit:false,
                isVisiblecargo:false,
                scrollTop:0,
                Currency:[], //货币代码
            };
        },
        create() {},
        beforeMount() {
            console.log('beforeMount');
            let that = this;
            that.getqwlist();
        },
        watch: {
            datajson: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted() {
            let that = this;
            that.intidata();
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[13391]"),this.$t("getapi[11]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                that.$refs.SetBtn.SetButtonEnable('create,refresh');
            },
            //获取查询条件
            serclick(val) {
                console.log(val);
                this.queryData = val;
                this.intidata();
                this.authority();
            },
            //修改页数
            handleSizeChange(val) {
                this.PageSize = val;
                this.$http.savePageSize('3_salecontrolsubject',val)
                this.intidata();
                this.authority();
            },
            //跳页
            handleCurrentChange(val) {
                this.PageIndex = val;
                this.intidata();
                this.authority();
            },
            //编辑
            editInfo(row) {
                let that = this;
                that.authority();
            },
            // 获取数据
            intidata() {
                let that = this;
                that.loading = true;
                this.isVisible = false;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: []
                };
                that.queryData.forEach(item => {
                    pm = {
                        row_sign: item.row_sign,
                        query_Condition: item.query_Condition,
                        query_sort: item.query_sort,
                        query_field_type: item.Query_Field_Type,
                        query_field_name: item.Query_Field_Name
                    };
                    parm.Param.push(pm);
                });
                console.log(parm);
                that.$http.urlpost('GL/Receive/GetReceiveControlSubject', parm, function(res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.datajson = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loading = false;
                    that.authority();
                });
            },
            selectCargo() {
                let that = this;
                that.isVisiblecargo=true;
                that.$refs.cargo.clearInput(true);
            },
            getCargo(data) {
                let that = this
                that.formInline._cargoposition_code = data.cargoposition_code

            },
            // 保存数据
            sava() {
                let that = this;
                if(that.formInline.receive_subject_code == '' || that.formInline.prereceive_subject_code == ''){
                    that.$message.warning(that.$t('getapi[13433]'))
                    return
                }
                that.loading = true;
                let parm = that.formInline
                that.$http.urlpost('GL/Receive/SaveReceiveSubject', parm, function(res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[284]'));
                        that.intidata();
                        that.editvisi = false;
                    }
                });
                that.loading = false;
            },
            // 获取查询条件
            getqwlist() {
                let that = this;
                that.$http.urlpost('Basic/Items/WorkCenterQWList', {}, function(res) {
                    that.queryData = res.DataContent;
                });
            },
            // 编辑
            edit(jsd) {
                let that = this;
                this.editvisi = true;
                this.formInline = {
                    Exclusively_ID: jsd.row.Exclusively_ID,
                    part_code: jsd.row.part_code,
                    part_name: jsd.row.part_name,
                    category_code: jsd.row.category_code,
                    category_name: jsd.row.category_name,
                    client_code: jsd.row.client_code,
                    client_name: jsd.row.client_name,
                    client_type_id: jsd.row.client_type_id,
                    client_type_name: jsd.row.client_type_name,
                    area: jsd.row.area,
                    currency_code: jsd.row.currency_code,
                    tax_code: jsd.row.tax_code,
                    receive_subject_code: jsd.row.receive_subject_code,
                    receive_subject_name: jsd.row.receive_subject_name,
                    tax_subject_code: jsd.row.tax_subject_code,
                    tax_subject_name: jsd.row.tax_subject_name,
                    sales_subject_code:jsd.row.sales_subject_code,
                    sales_subject_name:jsd.row.sales_subject_name,
                    prereceive_subject_code:jsd.row.prereceive_subject_code,
                    prereceive_subject_name:jsd.row.prereceive_subject_name,
                    subjecttype:jsd.row.subjecttype,
                };
                that.oldFormInline = JSON.stringify(that.formInline)
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = '';
                for (let i = 0; i < val.length; i++) {
                    that.selectIDData += val[i].Exclusively_ID + ',';
                }
                console.log(that.selectIDData);
            },
            // 删除
            delf() {
                let that = this;
                let parm = {
                    ids: that.ids
                };
                console.log(parm);
                that.$http.urlpost('GL/Receive/DeleteReceiveSubjectByID', parm, function(res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[659]'));
                        that.datajson.forEach(function(item, index) {
                            if (that.ids.indexOf(item.Exclusively_ID) >= 0) {
                                that.datajson.splice(index, 1);
                            }
                        });
                    }
                });
            },
            // 删除
            del(jsd) {
                this.ids = jsd.row.Exclusively_ID + ',';
                this.delf();
            },
            //批量删除
            delall() {
                let that = this;
                that.ids = this.selectIDData;
                that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//'此操作将永久删除该数据, 是否继续?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.delf();
                    })
                    .catch(() => {});
            },
            // 新增
            add() {
                this.formInline = {
                    Exclusively_ID: '',
                    part_code: '',
                    part_name: '',
                    category_code: '',
                    category_name: '',
                    client_code: '',
                    client_name: '',
                    client_type_id: '',
                    client_type_name: '',
                    area: '',
                    currency_code: '',
                    tax_code: '',
                    receive_subject_code: '',
                    receive_subject_name: '',
                    tax_subject_code: '',
                    tax_subject_name: '',
                    sales_subject_code: '',
                    sales_subject_name: '',
                    prereceive_subject_code: '',
                    prereceive_subject_name: '',
					subjecttype:1,
                };
                this.editvisi = true;
            },
            // 查询
            search() {
                this.isVisible = true;
                this.$refs.ser.clearInput(this.isVisible, 'salecontrolsubject');
            },
            // 刷新
            reflash() {
                this.intidata();
            },
			//科目
            selectSubject(type){
                let that = this
				that.subjecttype = type
                that.$refs.subject.clearInput(true);
            },
            getSubject(data){
                let that = this
                console.log(data)
                if(that.subjecttype == 1){
                    that.formInline.receive_subject_code = data['科目编码']
                    that.formInline.receive_subject_name = data['完整科目名称']
				} else if(that.subjecttype == 2){
                    that.formInline.tax_subject_code = data['科目编码']
                    that.formInline.tax_subject_name = data['完整科目名称']
				} else if(that.subjecttype == 3) {
                    that.formInline.sales_subject_code = data['科目编码']
                    that.formInline.sales_subject_name = data['完整科目名称']
                } else if(that.subjecttype == 4){
                    that.formInline.prereceive_subject_code = data['科目编码']
                    that.formInline.prereceive_subject_name = data['完整科目名称']
                }
            },
            //物料
            selectpart() {
                let that = this;
                that.$refs.part.clearInput(true);
            },
            getpart(data){
                let that = this
                console.log(data)
                that.formInline.part_code = data.part_code;
                that.formInline.part_name = data.part_name;
            },
            //存货类别
            selectcategory() {
                let that = this;
                that.$refs.category.clearInput(true);
            },
            getcategory(data){
                let that = this
                console.log(data)
                that.formInline.category_code = data.Category_Code;
                that.formInline.category_name = data.Category_Name;
            },
            //客户
            selectcustomer() {
                let that = this;
                that.$refs.customer.clearInput(true);
            },
            getcustomer(data){
                let that = this
                console.log(data)
                that.formInline.client_code = data.customer_id;
                that.formInline.client_name = data.customer_name;
                that.formInline.currency_code = data.currency_code_id;
                that.formInline.tax_code = data.currency_code_id
            },
            selectcustomertype() {
                let that = this;
                that.$refs.customertype.clearInput(true);
            },
            getcustomertype(data){
                let that = this
                console.log(data)
                that.formInline.client_type_id = data.Exclusively_ID;
                that.formInline.client_type_name = data.Customer_Type;
            },
            //地区
            selectarea() {
                let that = this;
                that.$refs.area.clearInput(true);
            },
            getarea(data){
                let that = this
                console.log(data)
                that.formInline.area = data.Area_Name;
            },
        }
    };
</script>

<style lang="scss" scoped>

	table {
		border-collapse: separate;
		border-spacing: 0px 5px;
		td {
			padding-left: 3px;
			white-space: pre;
		}
	}
	.el-form--inline .el-form-item {
		display: flex;
	}

	.tb-edit .el-input {
		display: none;
	}

	.tb-edit .current-row .el-input {
		display: block;
	}

	.tb-edit .current-row .el-input + span {
		display: none;
	}

	.el-table .hidden-row {
		display: none;
	}
</style>
